module.exports = __webpack_public_path__ + "media/images/top/top-og-image-1a8413b05051b2c91eaf71941ae27f2e.jpg";